<template>
     <div class="hello">
    <Header></Header>
    <el-row>
      <el-col :span="50" >
        <div class="intro">
          <div class="intro-content">
            <div class="grid-content bg-purple">
                <p>《中国企业家》主办的第23届“未来之星——2023年度‘21家高成长性创新公司’”及“新锐100”活动现已启动。</p>
                <p>今年“未来之星”的主题词是：涌现。面对由ChatGPT带起的硬核创业热潮，我们想找寻那些真正具有高成长性和创新性的年轻公司，观察它们如何一路通关，逐步成长为商界“鲨鱼苗”的。</p>
                <p>从2001年开始，“未来之星”就秉承着发现中国最具成长性新兴公司的愿景启动，至今历经22年、有462家公司入围、超过一半的入围公司成功上市或成为行业独角兽……在这个历程中，我们也见证着中国公司从PC互联网到移动互联网再到数智化时代的不断迭代。</p>
                <p>今年，《中国企业家》联合三十多家投资机构，继续找寻2023年度“未来之星”和“新锐100”公司。欢迎符合条件的公司报名参与。</p>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row>
        <router-link :to="{path:'/futurestar2023/collect'}" class="baomin">
        <el-image src="http://swapp.iceo.com.cn/Public/wlzx/2023/but-baoming.png"></el-image>
        </router-link>
        <!-- <div class="baomin" @click="submit_data">点击报名</div> -->
        <!-- <el-button class="fonts_bao"></el-button> -->
    </el-row>
     <img class="img_s" src="@/assets/images/pst-title.jpg" alt="评审团">


    <!-- 主要数据渲染框架 -->
    <div class="content_s">
        <el-row>
            <el-col :span="8" v-for="(item, index) in judry.data_o" :key="index">
                <el-card :body-style="{ padding: '0px'}">
                <img :src=" 'http://swapp.iceo.com.cn/Public/' +item.default_url+ item.intro_url" class="image">
                <div style="padding: 0px;">
                    <h3>{{item.name}} </h3>
                    <span>{{item.intro}} </span>
                </div>
                </el-card>
            </el-col>
        </el-row>
    </div>


     <!-- 主要数据渲染框架 -->
    <div class="content_s">
        <el-row>
            <el-col :span="8" v-for="(item, index) in judry.data_t" :key="index">
                <el-card :body-style="{ padding: '0px'}">
                <img :src=" 'http://swapp.iceo.com.cn/Public/' +item.default_url + item.intro_url" class="image">
                <div style="padding: 0px;">
                    <h3>{{item.name}}</h3>
                    <span>{{item.intro}} </span>
                </div>
                </el-card>
            </el-col>
        </el-row>
    </div>

      <!-- 支持机构 -->
    <img class="img_s" src="@/assets/images/zczg-title.jpg" alt="支持机构">
    <div class="content_s">
        <el-row>
            <el-col :span="8" v-for="(item, index) in judry.data_s" :key="index">
                <el-card :body-style="{ padding: '0px'}">
                <img :src="'http://swapp.iceo.com.cn/Public/' +item.default_url+ item.intro_url" class="image">
                </el-card>
            </el-col>
        </el-row>
    </div>
      <img class="img_s" src="@/assets/images/pxlc.jpg" alt="评选流程">

    <!-- <Bottom></Bottom> -->
  </div>
</template>

<script>

import Header from "@/components/public/Header.vue"
import Bottom from "@/components/public/Bottom.vue"
import wxShare from "@/assets/common/Untils.js"
export default {
   mixins: [wxShare],
    name: 'Show',
    data (){
        return {
            data:['1','2','3','4'],
            msg:'shuiahuiah',
            judry:'',
            url_getdata:'/api/getjudry',
            setinfo:{
              title:'',
              desc:'',
              link:'',
              img:''
            },
        }
    },
     mounted: function (){
     this.getjudry()
   },
    methods:{

        //获取评委
        getjudry(){
          this.$axios.get(this.url_getdata).then(res=>{
            this.judry = res.data
          })


          //获取标题描述等
          this.$axios.get('/api/getshare').then(res=>{

            var data_s= res.data
            const shareInfo = {
              title: data_s.title,
              desc: data_s.desc,
              link: data_s.link,
              img: data_s.img
            }

             this.wechatShare(shareInfo)
          })







        },
        submit_data(){
            // this.$router.push('/collect')
        }
    },
    components:{
    Header,
    Bottom
  }
}

</script>

<style scoped>
.content_s{
    padding: 12px 6%;
}
.content_s div div:nth-child(3n+1){clear: left;}
.img_s{display:block;width:100%;margin-bottom: 20px;}
.baomin{
    display:block;
    width:70%;
    height:45px;
    border: none;
    border-radius:6px;
    text-align: center;
    color: #000;
    /* background-color:#fff; */
    font-size:20px;
    margin:40px auto 40px;
    line-height:45px;
    text-decoration:none;
}
.fonts_bao{

}
.hello{
    background-color:#ef7c00;
    color:rgb(58, 2, 2);
    font-weight: bold;
}
 .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
.item h3{color:#e85a50;}
.icon_s{
  display: inline-block;
  width: 30px;
  height: 30px;
  background: #eea01e;
  text-align: center;
  line-height: 30px;
  border-radius: 10px;
  margin-right:15px;
  /* color:#fa5c00; */
  color:white;

}
  .text {
    font-size: 14px;
  }

  .item {
    padding: 18px 0;
  }

  .box-card {
    width: 100%;
    margin-bottom: 20px;
  }
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-card {
    margin: 0px 6px 20px;
    border: none;
    background:none;
    color:#fff;
  }

.el-card h3, .el-card span {
      font-size: 14px;
      font-weight: bold;
      margin: 10px 0px 4px;
      line-height: 18px;
    }
  .el-card span {
      font-size: 12px;
      line-height: 18px;
      display: block;
      margin: 0px;
       font-weight: normal;
    }



    .el-card.is-always-shadow {
      -webkit-box-shadow: 0 0 0 0 rgba(0,0,0,.1);

       box-shadow: 0 0 0 0 rgba(0,0,0,.1);
    }


  .el-col {
    /* margin-right:30px; */
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #f7f7f7;
  }

  .bg-purple-light {
    background: #f7f7f7;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    padding: 0px 8%;
  }
   .grid-content p{
       text-align:justify;
       margin:0px 0px 15px;
    }
  .row-bg {
    padding: 10px 0;
    background-color: #efeee8;
  }
  .pst-list{ float: left;width: 33.3333%; padding:10px 1%}
.el-divider--horizontal{
width: 90%;
margin: 30px auto 30px;
   }
.el-divider__text {
    position: absolute;
    background-color: #ea7c26;
    padding: 0 10px;
    font-weight: 500;
    color: #faee01;
    font-size: 12px;
}
.el-row[data-v-7c367ea6] {
    margin-bottom: 0px;

}
.el-divider{
  background-color: #faee01;
}
.intro{
  position: relative;
color: #fff;
font-size: 15px;
width:100%;
padding-top: 40px;
background:url('../assets/images/intro-bg.png') 0px 0px no-repeat ;
background-size: 100%;
}
.intro-content{
  width:94%;
  margin: 0 auto;
 max-height: 270px;
 overflow-y: scroll;
 left: 3%;
}
.intro-bg{
  position: absolute;
  top:0px;
  left: 0px;
}
::-webkit-scrollbar {
  /* 滚动条整体样式 */
  width: 2px;
  /* 宽高分别对应横竖滚动条的尺寸 */
  background:#ef7c00;
  border-radius: 10px;
  -webkit-box-shadow: inset 1px 0 1px #ffff0e;
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Show.vue